module.exports = __webpack_public_path__ + "img/vertical_6_7_3016.3f6c0a13.png";